/**
 * Íconos SVG del flujo premium (procesos de orden).
 * Bucket: `s3://brandfactory-assets/icons/` (verificado con `aws s3 ls s3://brandfactory-assets/icons/ --profile default`).
 * URLs HTTPS de lectura pública (mismo host que otros assets BrandFactory en la app).
 */
export const PREMIUM_FLOW_PROCESS_ICON_URL_COTIZACION =
    'https://brandfactory-assets.s3.amazonaws.com/icons/cotizacion.svg';

/** Cotización cuando el flujo incluye Coupa (primer proceso Coupa). */
export const PREMIUM_FLOW_PROCESS_ICON_URL_COTIZACION_COUPA =
    'https://brandfactory-assets.s3.amazonaws.com/icons/coupa-gray.svg';

export const PREMIUM_FLOW_PROCESS_ICON_URL_ORDEN_DE_COMPRA =
    'https://brandfactory-assets.s3.amazonaws.com/icons/precotizacion.svg';

export const PREMIUM_FLOW_PROCESS_ICON_URL_ENTREGA =
    'https://brandfactory-assets.s3.amazonaws.com/icons/producto-entregado.svg';

export const PREMIUM_FLOW_PROCESS_ICON_URL_FACTURA =
    'https://brandfactory-assets.s3.amazonaws.com/icons/orden-de-pago.svg';

export const PREMIUM_FLOW_PROCESS_ICON_URL_COMPLETADO =
    'https://brandfactory-assets.s3.amazonaws.com/icons/logo-gray.svg';
